angular.module('core')
    .factory('DateRangePickerConfig', function ($translate) {
        let def = {
            ranges: {},
            locale: {
                // applyLabel: $translate.instant("select.save"),
                // cancelLabel: $translate.instant("select.clear"),
                // fromLabel: $translate.instant("select.from"),
                // toLabel: $translate.instant("select.to"),
                // customRangeLabel: $translate.instant("select.custom-range"),
                applyLabel: "Zapisz",
                cancelLabel: "Wyczyść",
                fromLabel: "Od",
                toLabel: "Do",
                customRangeLabel: "Własny zakres",
                firstDay: 1
            },
            format: 'YYYY-MM-DD'
        };

        // var TODAY = $translate.instant("select.today");
        // var YESTERDAY = $translate.instant("select.yesterday");
        // var THIS_WEEK = $translate.instant("select.this-week");
        // var LAST_WEEK = $translate.instant("select.last-week");
        // var LAST_7D = $translate.instant("select.last-7D");
        // var LAST_30D = $translate.instant("select.last-30D");
        // var THIS_MONTH = $translate.instant("select.this-month");
        // var LAST_MONTH = $translate.instant("select.last-month");
        // var THIS_QUARTER = $translate.instant("select.this-quarter");
        // var LAST_QUARTER = $translate.instant("select.last-quarter");
        const TODAY = "Dziś";
        const YESTERDAY = "Wczoraj";
        const THIS_WEEK = "Ten tydzień";
        const LAST_WEEK = "Poprzedni tydzień";
        const LAST_7D = "Ostatnie 7 dni";
        const LAST_30D = "Ostatnie 30 dni";
        const THIS_MONTH = "Ten miesiąc";
        const LAST_MONTH = "Poprzedni miesiąc";
        const THIS_QUARTER = "Ten kwartał";
        const LAST_QUARTER = "Poprzedni kwartał";
        const THIS_YEAR = "Ten rok";
        const LAST_YEAR = "Poprzedni rok";

        def.ranges[TODAY] = [moment(), moment()];
        def.ranges[YESTERDAY] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
        def.ranges[THIS_WEEK] = [moment().startOf('week'), moment().endOf('week')];
        def.ranges[LAST_WEEK] = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
        def.ranges[LAST_7D] = [moment().subtract(6, 'days'), moment()];
        def.ranges[LAST_30D] = [moment().subtract(29, 'days'), moment()];
        def.ranges[THIS_MONTH] = [moment().startOf('month'), moment().endOf('month')];
        def.ranges[LAST_MONTH] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
        def.ranges[THIS_QUARTER] = [moment().startOf('quarter'), moment().endOf('quarter')];
        def.ranges[LAST_QUARTER] = [moment().subtract(1, "Q").startOf('quarter'), moment().subtract(1, "Q").endOf('quarter')];
        def.ranges[THIS_YEAR] = [moment().startOf('year'), moment().endOf('year')];
        def.ranges[LAST_YEAR] = [moment().subtract(1, "Y").startOf('year'), moment().subtract(1, "Y").endOf('year')];

        return {
            get: get
        };

        function get(override) {
            var result = angular.copy(def);
            angular.extend(result, override);
            return result;
        }

    })
    .directive('selectDateRange', function (DateRangePickerConfig, $timeout) {
        return {
            scope: {
                start: '=',
                end: '=',
                onChange: '&',
                options: '=',
                ngRequired: '=?'
            },
            template: `
                <input date-range-picker options="daterangepicker_options" class="form-control input-sm date-range-picker input-date-period" type="text"
                translate-attr="{ placeholder: selectOptions.placeholderKey }" ng-change="onModelChange()" ng-model="period" ng-required="ngRequired"/>
            `,
            link: function (scope) {
                scope.period = {};
                // if (scope.start) {
                //     scope.period.startDate = scope.start;
                // }
                // if (scope.end) {
                //     scope.period.endDate = scope.end;
                // }
                scope.$watch('start', () => scope.period = {startDate: scope.start, endDate: scope.end});
                scope.$watch('end', () => scope.period = {startDate: scope.start, endDate: scope.end});

                scope.onModelChange = () => {
                    // scope.start = scope.period.startDate ? moment(scope.period.startDate).toISOString() : null;
                    // scope.end = scope.period.endDate ? moment(scope.period.endDate).toISOString() : null;
                    scope.start = scope.period.startDate ? moment(scope.period.startDate).format('YYYY-MM-DD') : null;
                    scope.end = scope.period.endDate ? moment(scope.period.endDate).format('YYYY-MM-DD') : null;
                    $timeout(() => scope.onChange({start: scope.start, end: scope.end}));
                };

                const defaultOptions = {
                    placeholderKey: 'datetimepicker.chooserange'
                };
                scope.selectOptions = angular.extend({}, defaultOptions, scope.options);

                let options = {
                    eventHandlers: {
                        'cancel.daterangepicker': (ev, picker) => {
                            scope.period = {};
                            scope.onModelChange();
                        },
                        'apply.daterangepicker': (ev, picker) => scope.onModelChange()
                    }
                };
                scope.daterangepicker_options = DateRangePickerConfig.get(options);
            }
        };
    })
    .component('dateRangeFilterButton', {
        bindings: {
            start: '=',
            end: '=',
            onChange: '&',
            label: '@'
        },
        template: `
            <span class="date-range-filter-button" uib-tooltip="{{$ctrl.label}}">
                <i class="fa fa-fw fa-calendar" aria-hidden="true"></i>
                <select-date-range options="$ctrl.options" start="$ctrl.start" end="$ctrl.end" on-change="$ctrl.handleChange(start, end)"></select-date-range>
            </span>
        `,
        controller: function () {
            this.options = {placeholderKey: 'datetimepicker.chooserange'}
            this.handleChange = (start, end) => {
                this.start = start
                this.end = end
                this.onChange({start: start, end: end})
            }
        }
    })
